import { esc, openModal, closeModal, showModalErr } from '../ui/modal';
import { t } from '../ui/lang';
/**
 * Edit an existing clicker server (rename / change host / rotate salt).
 * The salt field starts empty — leaving it blank keeps the stored secret,
 * which the list only ever shows masked.
 */
export function showEditClickerServerModal(server, onSaved) {
    const modal = openModal(`
        <h2 class="modal__title">${t('clickertab.edit_server')}</h2>
        <form id="cse-form" class="modal__form" novalidate>
            <div class="modal__field">
                <label>${t('common.name')}</label>
                <input id="cse-name" type="text" autocomplete="off" maxlength="100" value="${esc(server.name)}" required />
            </div>
            <div class="modal__field">
                <label>${t('clickertab.host')}</label>
                <input id="cse-host" type="text" autocomplete="off" value="${esc(server.host)}" required />
            </div>
            <div class="modal__field">
                <label>${t('clickertab.salt')}</label>
                <input id="cse-salt" type="text" autocomplete="off" placeholder="${t('clickertab.salt_keep_placeholder')}" />
                <p class="modal__hint">${t('clickertab.salt_replace_hint')}</p>
            </div>
            <div id="cse-error" class="modal__error" style="display:none"></div>
            <div class="modal__actions">
                <button type="button" class="modal__cancel" id="cse-cancel">${t('common.cancel')}</button>
                <button type="submit" class="modal__submit">${t('common.save')}</button>
            </div>
        </form>
    `);
    modal.querySelector('#cse-cancel').addEventListener('click', closeModal);
    const form = modal.querySelector('#cse-form');
    const nameInput = modal.querySelector('#cse-name');
    const hostInput = modal.querySelector('#cse-host');
    const saltInput = modal.querySelector('#cse-salt');
    const errorEl = modal.querySelector('#cse-error');
    const submitBtn = form.querySelector('.modal__submit');
    form.addEventListener('submit', async (e) => {
        e.preventDefault();
        errorEl.style.display = 'none';
        const name = nameInput.value.trim();
        const host = hostInput.value.trim();
        const salt = saltInput.value.trim();
        if (!name) {
            showModalErr(errorEl, t('clickertab.err_name_required'));
            return;
        }
        if (!host) {
            showModalErr(errorEl, t('clickertab.err_host_required'));
            return;
        }
        submitBtn.disabled = true;
        try {
            const r = await fetch(`/api/clicker/servers/${server.id}`, {
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ name, host, ...(salt ? { salt } : {}) }),
            });
            if (!r.ok) {
                showModalErr(errorEl, (await r.json()).error ?? t('clickertab.err_failed_save_server'));
                return;
            }
            closeModal();
            onSaved();
        }
        catch {
            showModalErr(errorEl, t('clickertab.network_error'));
        }
        finally {
            submitBtn.disabled = false;
        }
    });
    nameInput.focus();
    nameInput.select();
}
